import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import './CustomerModals.scss'

function CreatePaystackAccount({ userId, onSuccess, onClose }: any) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)

  async function confirm() {
    setLoading(true)
    post(`admin/users/${userId}/create-paystack-account`, {}, null)
      .then((result: any) => {
        if (result.success) {
          notify('success', result.message)
          onSuccess(result.data)
          onClose()
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div className='modal-icon icon-green'>
            <Icon icon='mdi:bank-plus' />
          </div>
          <h2>Create Paystack Account</h2>
          <p>
            This customer has no dedicated account number, usually because
            Paystack failed when they signed up. This will ask Paystack to
            create one now. If it fails again, the Paystack error will be shown.
          </p>
        </div>

        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={onClose}>
              Cancel
            </button>
            <button className='btn-proceed' onClick={confirm}>
              Create Account
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default CreatePaystackAccount
